export const getProvidersName = ({ firstName, lastName, title }) => {
  return `${firstName} ${lastName} ${title.toUpperCase()}`;
};

export const getGenderSpecialties = (specialties, gender) => {
  let strToReturn = gender
    ? `${gender.replace(/^./, gender[0].toUpperCase())} - `
    : "";
  specialties.forEach(
    (specialty, i) =>
      (strToReturn += i === 0 ? specialty.name : `, ${specialty.name}`)
  );
  return strToReturn;
};

export const getAddress = ({ street, city, state, zip }) => {
  return `${street}, ${city}, ${state}, ${zip}`;
};

export const getFormatedPhoneNumber = ({ phones }) => {
  return phones[0].number.replace(/^(\d{3})(\d{3})(\d{4}).*/, "($1) $2-$3");
};

export const getEducations = educations => {
  return educations.map(e => e.school).join("\n");
};
